<template>
  <div class="certificate">
    <app-Certificate></app-Certificate>
  </div>
</template>

<script>
// @ is an alias to /src
import certificate from "../components/certificate/certificate";
export default {
  name: "about",
  components: {
    appCertificate: certificate
  }
};
</script>
